import type { Moment } from './moment'
import moment from './moment'

export class SerializedMoment {
  static readonly key = 'moment:27100575-BE9C-4F3F-B8AB-365AD1B2713F'
  static toJSON(value: Moment) {
    return {
      key: SerializedMoment.key,
      data: value.format(),
    }
  }

  static fromData(data: any) {
    try {
      if (data.key !== SerializedMoment.key) return undefined
      return moment(data.data)
    } catch {
      return undefined
    }
  }
}

export class TimezonelessSerializedMoment {
  static readonly key = 'moment:DC657FCE-1940-4F54-831D-469C5402FDBB'
  static toJSON(value: Moment) {
    return {
      key: TimezonelessSerializedMoment.key,
      data: value.format('YYYY-MM-DDTHH:mm:ss'),
    }
  }

  static fromData(data: any) {
    try {
      if (data.key !== TimezonelessSerializedMoment.key) return undefined
      return moment(data.data)
    } catch {
      return undefined
    }
  }
}
